/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable react/no-unescaped-entities */

import { NotFoundComponent } from '@modules/core/components/NotFoundComponent';
import { IS_SPAIN_ENV } from '@modules/core/utils';

export const PrivacyPolicy = () => {
  if (IS_SPAIN_ENV) {
    return <NotFoundComponent />;
  }

  return (
    <div style={ { padding: '24px' } }>
      <h2 style={ { textAlign: 'center' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            PRIVACY POLICY
          </span>
        </strong>
      </h2>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          This Privacy Policy (“
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            Privacy Policy
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          ”) describes how Huspy (“
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            Huspy
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          ”, “
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            us
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          ”, “
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            we
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          ” and “
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            our
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          ”) collects, uses and shares Personal Data (as described below) of you
          (“
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            you
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          ”), as the User of our Platform and the Services, and your Client.
          Terms used in this Privacy Policy not defined herein, shall have the
          same meanings ascribed to them in our Terms and Conditions.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          By using our Services and/or accessing our Platform, you are accepting
          the terms of this Privacy Policy and are consenting to our collection,
          use, disclosure, retention and protection of your and your Clients’
          Personal Data, as described in more detail herein. You acknowledge and
          agree that you are solely responsible for obtaining the consent of
          each of your Clients prior to submitting any Personal Data to us
          and/or onto the Platform.&nbsp;
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We reserve the right to amend this Privacy Policy at any time without
          prior notice to you or your Clients. It shall be your sole
          responsibility to review this Privacy Policy periodically and update
          yourself and your Clients of any changes that might be made. By
          continuing to access our Platform and/or use the Services, you are
          accepting the terms of this Privacy Policy in full. Should you not
          agree to any of the terms in this Privacy Policy, you should stop
          accessing our Platform and/or using the Services immediately.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            PERSONAL DATA THAT WE COLLECT
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may collect Personal Data about you, your Client and any devices
          you use when you access our Platform and use the Services, when you
          correspond with us regarding the Platform or the services provided
          through it, and when you generally access our Platform for any reason
          whatsoever.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          "
        </span>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            Personal Data
          </span>
        </strong>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          " includes any data which may be used to identify or contact an
          individual, including but not limited to, name, address, telephone
          number, email address, date of birth, nationality, username and/or
          other data which may be necessary to create an account on the Platform
          &nbsp;or use the Services and complete a transaction. Personal Data of
          your Client may also include, without limitation, financial data, such
          as salary and bank details, and occupation information. Personal Data
          shall not include aggregated data or data that, by itself, does not
          permit the identification of individual persons.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Personal Data that is transmitted to us may include, but is not
          limited to:
        </span>
      </p>
      <ul style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Information which can identify an individual such as name,
              address, telephone number, username and email address;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              RFID-linked personal information contained in Emirates ID,
              Passport and any other document that you share with us;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Financial data (such as credit card or bank account numbers when
              you pay for the third party Services via our Platform and/or data
              relating to your Clients financial status when applying for a
              mortgage);
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Postage, billing and other Personal Data used to purchase and/or
              process Services through the Platform;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Data through a web form or when you correspond with us regarding
              the Services;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Profile information of any third-party platform that you may
              choose to use to log in or sign up to our Platform;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Other information voluntarily provided by you and/or your Client;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Any other information we need to enable us to deliver any services
              to you and/or your Client; and
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              Additional data required by applicable laws to collect and process
              an order to authenticate or identify you and/or your Client or to
              verify the data that we have collected is correct.
            </span>
          </p>
        </li>
      </ul>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We will only gather Personal Data that is relevant for the purposes
          for which it will be used and will not gather excessive or unnecessary
          Personal Data about you or your Client.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may also collect Personal Data about and/or from your interactions
          with our Platform; your advertising preferences; your communications
          with us; and computer and connection data such as statistics on your
          page views, traffic to and from the sites, referral URL, ad data, your
          IP address, your browsing history and your web log data. This is
          Personal Data we receive from the devices you use when you access our
          Platform, register to receive Services, provide us data on a web form,
          or when you otherwise correspond with us regarding the Services.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            COOKIES
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may use cookies, web beacons, unique identifiers and similar
          technologies to collect data about the pages that you view, the links
          that you click and other actions you may take on our Platform, within
          our advertising or e-mail content.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          You can typically remove and reject cookies from our Platform with
          your browser settings. Many browsers are set to accept cookies until
          you change your settings. If you remove or reject our cookies, it
          could affect how our Platform works for you.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            OUR USE OF PERSONAL DATA
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may use the Personal Data we collect about you and your Clients to
          provide you and your Clients with continuity in services, customer
          service, a personalized experience when you visit our Platform, a
          personalized advertising and marketing experience; to contact you
          about our Platform or the services we provide through it; and to
          detect, prevent, mitigate and investigate fraudulent or illegal
          activities.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may therefore use and retain your and/or your Clients’ Personal
          Data as follows:
        </span>
      </p>
      <ul style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to give access to the Services provided through our Platform;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to operate, maintain, and improve our Platform and the services
              provided through it;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to send data including confirmations, invoices, technical notices,
              updates, security alerts, support and administrative messages;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to communicate about promotions, upcoming events, and other news
              about products and services offered by us and our selected
              partners;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to link or combine User data with other Personal Data;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to customize, measure and improve our services; and
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              to provide you with location-based services (such as advertising,
              search results and other personalized content using your GPS).
            </span>
          </p>
        </li>
      </ul>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Personal Data may be transferred to our group companies, Service
          Providers that are performing services on our/your/your Clients’
          behalf, or persons acting as our agents (which may be located in a
          country outside of your country of origin). We will require that any
          such parties agree to keep Personal Data secure and confidential, use
          it only for the purposes for which the Personal Data is transferred
          and use it only in accordance with our directions and subject always
          to the provisions of this Privacy Policy. Personal Data may be
          transferred to any government authority, agency and institution if and
          as required or permitted by applicable laws and regulations.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We take precautions to protect your and your Clients’ Personal Data.
          We have or may implement policies that forbid our employees or anyone
          having access to Personal Data from using or disclosing Personal Data
          in an inappropriate or unlawful manner, and maintain security measures
          to safeguard the Personal Data from unauthorized access, misuse,
          alteration, loss or destruction. We shall not collect, use, disclose
          or transfer the Personal Data except as described in this Privacy
          Policy, unless you and/or your Client give us your permission to
          collect, use, disclose or transfer it for other purposes.&nbsp;
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Personal Data is retained only for as long as necessary to fulfill the
          purposes described within this Privacy Policy and in accordance with
          our internal data retention policies. Once it is no longer needed, it
          will be securely deleted or anonymized.
        </span>
      </p>
      <h2 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            THIRD PARTY PERSONAL DATA
          </span>
        </strong>
      </h2>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          If you give us Personal Data about someone else, such as your Clients,
          you must do so only with their explicit and prior consent. You must
          inform them how we collect, use, disclose and retain their Personal
          Data according to this Privacy Policy.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            LINKS TO OTHER WEBSITES
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Our Platform may from time to time contain links to and from other
          websites. This may include websites owned or controlled by independent
          parties not controlled or authorized by us. If you follow a link to
          any of these websites please note that these websites have their own
          privacy policy, data collection practices and security measures and we
          do not accept any responsibility or liability for these policies.
          Please ensure you check these policies before submitting any personal
          data.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            SHARING OF PERSONAL DATA
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may disclose your and/or your Clients’ Personal Data to third
          parties. This disclosure may be required for us to provide you access
          to our Platform and the Services, to comply with our legal
          obligations, to enforce our Terms and Conditions, to facilitate our
          marketing and advertising activities, or to prevent, detect, mitigate
          and investigate fraudulent or illegal activities related to our
          Platform and/or Services. We minimize the amount of Personal Data we
          disclose to what is directly relevant and necessary to accomplish the
          specified purpose. We do not disclose Personal Data to third parties
          for their marketing and advertising purposes without your explicit
          consent.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We may disclose the collected Personal Data for the following
          purposes:
        </span>
      </p>
      <ul style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              To help detect and prevent potentially fraudulent and illegal
              acts, violations of our Terms and Conditions, and data security
              breaches.&nbsp;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              To third party service providers who help us to provide and/or
              achieve: the Services through our Platform; payment processing for
              the usage of Services; bill collection; customized advertising;
              the prevention, detection, mitigation and investigation of
              potentially illegal acts, violations of our Terms and Conditions,
              fraud and/or security breaches; affiliate and rewards programs;
              co-branded credit cards; and/or other business operations.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share Personal Data when we do a business deal, or
              negotiate a business deal, involving the sale or transfer of all
              or a part of our business or assets. These deals can include any
              merger, financing, acquisition, or bankruptcy transaction or
              proceeding.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share Personal Data for legal, protection, and
              safety/safeguarding purposes.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              To comply with our legal requirements, enforce our Terms and
              Conditions, respond to claims that any content violates the rights
              of others, or to protect anyone's rights, property or safety.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              With law enforcement or governmental agencies, or authorized
              third-parties, in response to a verified request relating to a
              criminal investigation or alleged or suspected illegal activity or
              any other activity that may expose us, you, your Client or any
              other of our Users to legal liability. We will only disclose data
              we deem relevant to the investigation or inquiry
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              With credit agencies or bureaus as authorized by applicable
              national laws (e.g. data on late or missed payments or other
              defaults that may be reflected in your/your Clients’ credit report
              or file).&nbsp;
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share data to respond to lawful requests and legal
              processes.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share data to protect the rights and property of Huspy’s
              group companies, our agents, customers, and others. This includes
              enforcing our agreements, policies, and Terms and Conditions.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share data in an emergency. This includes protecting the
              safety of our employees and agents, our customers, or any person.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share data with those who need it to complete work for us
              related to the Services.
            </span>
          </p>
        </li>
        <li
          style={ {
            listStyleType: 'disc',
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          <p style={ { textAlign: 'justify' } }>
            <span
              style={ {
                color: '#1a202c',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
              } }
            >
              We may share data to our external service providers such as
              digital service providers and IT service providers. Some of these
              may be located overseas.
            </span>
          </p>
        </li>
      </ul>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Disclosure of information by Huspy to third parties is not considered
          to be a violation of the Privacy Policy if it is performed based on
          any additional agreements related to distribution of our Services to
          you and/or your Clients. For example, we may hire third party
          companies to process payments, store data, host sites and access APIs.
          We will share the Personal Data with third parties only in the ways
          and amounts necessary for provision of our Services. Huspy appointed
          third parties have no right to use such Personal Data other than as
          directed by us.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We utilize Google Application Programming Interfaces (APIs) and
          Artificial Intelligence (AI) tools throughout the provision of our
          Services to you (and/or your Client) in order to improve user
          experience, enhance and personalize our Services, and drive business
          insights. Our use of information received from Google APIs and
          transfer of such information to any other third party service provider
          will adhere to the Google API Services User Data Policy, including its
          Limited Use requirements. AI tools are used for administrative
          purposes to (i) process Personal Data in a manner that reduces the
          turnaround time of the Services provided, by allowing us to
          efficiently complete forms and applications that require Personal Data
          input and (ii) to help answer questions you may have on lender
          policies/procedures when preparing Client applications. AI tools
          and/or models are not used for any decision-making exercises. Personal
          Data processed using AI tools helps us train and refine our AI tools
          to provide better Services to you and is subject to the same
          guidelines and procedures set out in this Privacy Policy.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            UPDATED DATA
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We take steps to ensure that the Personal Data we collect from you is
          accurate and up to date, and that you have the ability to access and
          make corrections to it, which includes reviewing and updating your and
          your Clients’ Personal Data upon request and honoring any statutory
          right you and/or your Clients might have to access, rectify, restrict,
          modify or erase the Personal Data we hold. You have a responsibility
          to keep the data that you provide to us updated and we will take
          reasonable steps to facilitate this. Where you have and/or your Client
          has a statutory right to request access, rectification, restriction,
          objection of use, modification or erasure of Personal Data, we can
          still withhold that access or decline the request in some cases in
          accordance with applicable laws, but will give you reasons if we do
          so.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            DATA CHOICES
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Our marketing emails tell you how to “opt-out” of receiving such
          emails. If you opt out, we may still send you non-marketing emails.
          Non-marketing emails include emails about the Services we are
          providing you and/or your Clients and our business dealings with you
          and your Clients.&nbsp;
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          You may sign-up to receive emails or newsletters from us. If you would
          like to discontinue receiving this data, you may update your email
          preferences by replying to the email or clicking the "unsubscribe"
          link found in emails we send to you.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          You may send requests about Personal Data to our Contact Data below.
          You can request to change contact choices, opt-out of our sharing of
          Personal Data with others, and update your Personal Data.
        </span>
      </p>
      <p style={ { textAlign: 'justify' } }>
        <br />
      </p>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          Note that if you choose to 'opt-out' of certain options, withhold,
          block or request that we delete your Personal Data, you may not be
          able to receive the benefit of our Platform or Services.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            WHERE WE STORE YOUR DATA
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          The data that we collect from you may be transferred to and stored at
          a destination outside UAE. It may also be processed by staff operating
          outside the UAE working for us. Such staff may be engaged in, among
          other things, the fulfilment of your transaction, the processing of
          your payment details and the provision of support services. By
          submitting Personal Data, you agree to this transfer, storing and
          processing on behalf of yourself and your Clients. We will take all
          steps reasonably necessary to ensure that your data is treated
          securely, in accordance with your rights and in accordance with this
          Privacy Policy. All information you provide to us is stored on our
          secure servers. Unfortunately, the transmission of information via the
          internet is not completely secure. Although we will do our best to
          protect your Personal Data, we cannot guarantee the security of your
          data transmitted to our Platform and any transmission is at your own
          risk.
        </span>
      </p>
      <h3 style={ { textAlign: 'justify' } }>
        <strong>
          <span
            style={ {
              color: '#1a202c',
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
            } }
          >
            CONTACT DATA
          </span>
        </strong>
      </h3>
      <p style={ { textAlign: 'justify' } }>
        <span
          style={ {
            color: '#1a202c',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
          } }
        >
          We welcome your comments or questions about this Privacy Policy. You
          may also contact us at our address: 7th Floor, The Bay Gate, Business
          Bay, Dubai, United Arab Emirates and by email at dpo@huspy.com.
        </span>
      </p>
    </div>
  );
};
